import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance, { isAxiosError } from "@/utils/axiosInstance";
import { Params } from "@/types/params";

const endpoint = {
  plans: "/plans",
};

export const fetchPlans = createAsyncThunk(
  "plans/fetchPlans",
  async (params: Params, thunkAPI) => {
    try {
      const response = await axiosInstance.get(endpoint.plans, {
        params,
      });
      return response.data;
    } catch (error) {
      if (isAxiosError(error)) {
        return thunkAPI.rejectWithValue({ error: error.message });
      } else {
        return thunkAPI.rejectWithValue({
          error: "An unknown error occurred",
        });
      }
    }
  },
);

export const createPlans = createAsyncThunk(
  "plans/createPlans",
  async (data: any, thunkAPI) => {
    try {
      const response = await axiosInstance.post(endpoint.plans, data);
      return response.data;
    } catch (error) {
      if (isAxiosError(error)) {
        return thunkAPI.rejectWithValue({ error: error.message });
      } else {
        return thunkAPI.rejectWithValue({
          error: "An unknown error occurred",
        });
      }
    }
  },
);

export const updatePlans = createAsyncThunk(
  "plans/updatePlans",
  async (data: any, thunkAPI) => {
    try {
      const response = await axiosInstance.put(
        `${endpoint.plans}/${data.id}`,
        data,
      );
      return response.data;
    } catch (error) {
      if (isAxiosError(error)) {
        return thunkAPI.rejectWithValue({ error: error.message });
      } else {
        return thunkAPI.rejectWithValue({
          error: "An unknown error occurred",
        });
      }
    }
  },
);

export const deletePlans = createAsyncThunk(
  "plans/deletePlans",
  async (slug: string, thunkAPI) => {
    try {
      const response = await axiosInstance.delete(`${endpoint.plans}/${slug}`);
      return response.data;
    } catch (error) {
      if (isAxiosError(error)) {
        return thunkAPI.rejectWithValue({ error: error.message });
      } else {
        return thunkAPI.rejectWithValue({
          error: "An unknown error occurred",
        });
      }
    }
  },
);
